import { AdministratorModel } from '../models/Administrator.model';
import { AdministratorDTO } from '../dtos/Administrator.dto';

export class AdministratorUtil {
  public static mapToViewModel(dto: AdministratorDTO): AdministratorModel {
    return {
      id: dto.id,
      fullName: dto.userDetails.fullName,
      email: dto.userDetails.email,
      username: dto.userDetails.username,
      isDeleted: dto.userDetails.isDeleted ? dto.userDetails.isDeleted : false,
    };
  }
}
